/* User profile action options */
export enum UserProfileAction {
  SET_EMAIL_AS_VERIFIED = 'setEmailAsVerified',
  ADMIN_NOTES = 'adminNotes',
  BAN_MEMBER = 'banMember',
  MANAGE_ROLES = 'manageRoles'
}
